import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ITranslatedContent, IContent } from '../../services/surveyContent';
import ModalHeader from './ScheduleContent/ModalHeader/ModalHeader';
import ScheduleModalTabs from './ScheduleContent/ModalTabs/ModalTabs';
import {
  ViewButton,
  TextAreaInputs,
  TextAreaInput,
} from './ScheduleContent/ScheduleContent.styles';
import CustomModal from '../../shared/CustomModal/CustomModal';
import SafeHtml from '../SafeHtml/SafeHtml';

interface IContentModal {
  getContent: (id?: string) => Promise<ITranslatedContent>;
  externalSurveyId: string;
  surveyId?: string;
  isReminder?: boolean;
}

export const ContentModal = ({
  getContent,
  surveyId,
  externalSurveyId,
  isReminder,
}: IContentModal) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const [content, setContent] = useState<IContent>();
  const [activeTab, setActiveTab] = useState<'internal' | 'external'>('internal');

  const handleClick = () => {
    const id = activeTab === 'external' ? externalSurveyId : surveyId;
    getContent(id).then((resp: ITranslatedContent) => setContent(resp[language]));
  };

  useEffect(() => {
    handleClick();
  }, [activeTab]);

  return (
    <CustomModal
      triggerButton={<ViewButton onClick={handleClick}>{t('viewSurvey.schedule.view')}</ViewButton>}
      header={<ModalHeader />}
      body={
        <div style={{ marginTop: '1rem', padding: '0 24px 20px 24px' }}>
          <ScheduleModalTabs
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            isReminder={isReminder}
            show={!!externalSurveyId}
          >
            <TextAreaInputs>
              <SafeHtml as={TextAreaInput} px={'2rem'} width={'100%'} html={content?.subject} />
              <SafeHtml
                as={TextAreaInput}
                px={'400px'}
                width={'100%'}
                overflowY={'auto'}
                html={content?.content}
              />
            </TextAreaInputs>
          </ScheduleModalTabs>
        </div>
      }
    />
  );
};
